import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Layout from "../Components/Layout/Body/index";
import { Login } from "../Pages/Login";
import { TermsAndConditions } from "../Pages/TermsAndConditions/index";
import { PrivacyPolicy } from "../Pages/Privacy/index";

import { LandingPage } from "../Pages/LandingPage";
import { PricingPage } from "../Pages/Payment";
import { LoginLandingPage } from "../Pages/LoginLanding";
import NewEnquiryPage from "../Pages/NewEnquiry";
import { Home } from "../Pages/Home";
import ProtectedRoute from "../RouterPath/protectedRoute"; // Import ProtectedRoute

import { Dashboard } from "../Pages/Dashboard";
import { RunPost } from "../Pages/RunPost"; // Import Leads page
import { SafePost } from "../Pages/SafePost"; // Import Leads page
import { EmailCampaign } from "../Pages/EmailCampaign";
import { SMSCampaign } from "../Pages/SMSCampaign"; // Import Leads page
import { Approvals } from "../Pages/Approvals"; // Import Leads page
import { Users } from "../Pages/Users"; // Import Leads page
import { Settings } from "../Pages/Settings";
import MarketingAssets from "../Pages/MarketingAssets";
import SecureAccountsTable from "../Pages/SecureAccounts";
import CalendarSchedule from "../Pages/Scheduler/CalendarSchedule";
import { TwitterSuccess } from "../Pages/TwitterSuccess";
import { FacebookSuccess } from "../Pages/FacebookSuccess";

const RoutePath = ({ isDarkTheme }) => {
  useEffect(() => {
    const handleInvalidToken = (e) => {
      if (e.key === "apptoken" && e.oldValue && !e.newValue) {
      }
    };

    window.addEventListener("storage", handleInvalidToken);
    return function cleanup() {
      window.removeEventListener("storage", handleInvalidToken);
    };
  }, []);

  return (
    <div className="App">
      <Routes>
        {/* Public Routes without Layout (no header/menu) */}
        <Route path="/termsandconditions" element={<TermsAndConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/new-enquiry" element={<NewEnquiryPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/login" element={<Login />} />

        {/* Twitter/Facebook OAuth handoff lands here - standalone (no header/menu), same treatment as /login */}
        <Route element={<ProtectedRoute />}>
          <Route path="/twitter-success" element={<TwitterSuccess />} />
          <Route path="/facebook-success" element={<FacebookSuccess />} />
        </Route>

        <Route element={<Layout isDarkTheme={isDarkTheme} />}>
          {/* Public Routes with Layout */}

          <Route path="/" element={<LoginLandingPage />} />
          <Route path="/landing" element={<LandingPage />} />

          {/* <Route path="/enquiry" element={<Enquiry />} /> */}

          {/* Protected Route - Enquiry */}
          <Route element={<ProtectedRoute />}>
            <Route path="/home" element={<Home />} />

            {/* Role-Based Routes */}
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/run-post" element={<RunPost />} />
            <Route path="/safe-post" element={<SafePost />} />
            <Route path="/email-campaign" element={<EmailCampaign />} />
            <Route path="/sms-campaign" element={<SMSCampaign />} />
            <Route path="/approvals" element={<Approvals />} />
            <Route path="/users" element={<Users />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/marketing-assets" element={<MarketingAssets />} />
            <Route path="/secure-accounts" element={<SecureAccountsTable />} />
            <Route path="/calendar-schedule" element={<CalendarSchedule />} />
            {/* Add more role-based routes as needed */}
          </Route>
        </Route>
      </Routes>
    </div>
  );
};
export default RoutePath;
